const validateFullName = (fullName: string): string => {
  if (!fullName.trim()) return '';

  if (fullName.trim().length < 2) return 'Full name must contain at least 2 characters';

  const allowedPattern = /^[A-Za-zÀ-ÖØ-öø-ÿ\s\-'.]+$/;
  const consecutiveSpecials = /[-'.]{2,}/;

  if (!allowedPattern.test(fullName)) {
    return 'Full name can only contain letters, spaces, hyphens, apostrophes, and periods';
  }

  if (consecutiveSpecials.test(fullName)) {
    return 'Full name cannot contain consecutive special characters';
  }

  return '';
};

export default validateFullName;
